import * as React from "react";
import {} from "@blueprintjs/core";
import { SmallFormGenerator, ISmallFormGeneratorProps } from "../../components/SmallFormGenerator";

export interface IDrupalFormGeneratorProps<T> extends ISmallFormGeneratorProps<T> {}

export function DrupalFormGenerator<T>(props: React.PropsWithChildren<IDrupalFormGeneratorProps<T>>) {
  return (
    <SmallFormGenerator minLabelWidth={220} showColons={false} large={true} responsiveColumnMinWidth={600} {...props} />
  );
}
